import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {PaymentRequestModel} from '../../../api/entity/paymentRequest.model';
import {PaymentRequestConverter} from '../../../api/entity/converter/paymentRequest.converter';


@Injectable({providedIn: 'root'})
export class PaymentRequestDataService extends AbstractDataServiceV2<PaymentRequestModel,
    PaymentRequestConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PaymentRequestConverter) {
        super('PaymentRequest', http, httpUrlGenerator, logger, config, converter);
    }
}
